import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { URI } from 'src/app/settings/uri-constants';

@Component({
    selector: 'app-manage',
    templateUrl: './manage.component.html',
    styleUrls: ['./manage.component.css'],
})
export class ManageComponent implements OnInit {
    constructor(private router: Router) {}

    ngOnInit() {
        this.router.navigate([URI.SLASHED_SEARCH]);
    }
}
